module.exports = __webpack_public_path__ + "assets/img/img311.8b83bee2.png";